window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};
$( document ).ready(function() {
  if($(window).width() > 1024) {
    // $('.prom-tuxedo-features').slick('unslick');
    
    if($('.prom-tuxedo-features .store-info').hasClass('slick-initialized')){
      $('.prom-tuxedo-features .store-info').slick('unslick');
    }
  }

  // Product Page start
  var $product_container = $('[data-section-type=product]');
  $product_container.on('variantChange', updateVariantRelatedFields.bind(this));

  // Product Page end

});

function updateVariantRelatedFields(evt) {
  let variant = evt.variant;
  if (variant){
    if (variant.available) {
      $('.product__inquiry-btn').hide();
      $('.arrival_date').hide();
    }else{
      $('.product__inquiry-btn').show();
      $('.arrival_date').show();
    }
  }
}

var addinToCart = window.newAddinToCart;
window.newAddinToCart = function() {
  addinToCart();
  console.log('extend---------')
}